import ApplicationController from './application'

import {
  removeClassFromList,
  toggleClass
} from '../helpers/helpers'

export default class extends ApplicationController {

  static targets = [
    'select',
  ]

  connect() {
    const formTarget = this.hasSelectTarget
    if (!formTarget) return

    this.#generateList(this.selectTarget)

    /* If the user clicks anywhere outside the select box,
    then close the open select box: */
    document.addEventListener('click', this.#closeCurrentSelect.bind(this))
  }

  optionClickEvent(event) {
    /* When an item is clicked, update the original select box,
    and the selected item: */
    let x, y, activeItem, selectElement, selectLength, activeItemLength
    selectElement = event.target.parentNode.parentNode.getElementsByTagName('select')[0]
    selectLength = selectElement.length
    for (x = 0; x < selectLength; x++) {
      if (selectElement.options[x].innerHTML == event.target.innerHTML) {
        this.#selectItem(selectElement, x)
        activeItem = event.target.parentNode.getElementsByClassName('-active')
        activeItemLength = activeItem.length
        for (y = 0; y < activeItemLength; y++) {
          activeItem[y].classList.remove('-active')
        }
        event.target.classList.add('-active')
        break
      }
    }
  }

  selectClickEvent(event) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    event.preventDefault()
    event.stopPropagation()
    event.target.focus()
    const listElement = event.target.closest('.custom-select').querySelector('.custom-select__list')
    !listElement.classList.contains('-open') && this.#closeAllSelect()
    toggleClass(listElement, '-open')
  }

  selectKeyEvent(event) {
    /* Listen for key events: */
    const listElement = event.target.closest('.custom-select').querySelector('.custom-select__list')
    const isOpen = listElement.classList.contains('-open')

    /* Open current select list: */
    if (!isOpen && event.key === 'ArrowDown') {
      event.stopPropagation()
      this.#closeAllSelect()
      listElement.classList.toggle('-open')
      return
    }

    if (isOpen) {
      /* Perform various actions on the open select list: */
      this.#openListEvent(event, listElement)
    }
  }

  #isMobile() {
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())
  }

  #isMac() {
    return (/mac os x/i.test(navigator.userAgent.toLowerCase()))
  }

  #closeCurrentSelect(event) {
    const openDropdown = document.querySelector('.custom-select__list.-open')
    const isLabel = event.target.tagName.toLowerCase() === 'label'
    if (!openDropdown || isLabel) return

    const isDropdown = event.target.classList.contains('custom-select__list')
    !isDropdown && openDropdown?.classList.remove('-open')
  }

  #openListEvent(event, listElement) {
    /* Prevent form submission when interacting with the open select list: */
    event.stopPropagation()

    let listItems = listElement.children
    let selectedItem = listElement.querySelector('.-active')

    if (event.key === 'ArrowUp') {
      return this.#navigateList(listItems, selectedItem, selectedItem?.previousElementSibling, listItems.length - 1)
    }

    switch (event.key) {
      case 'ArrowUp':
        this.#navigateList(listItems, selectedItem, selectedItem?.previousElementSibling, listItems.length - 1)
        break
      case 'ArrowDown':
        this.#navigateList(listItems, selectedItem, selectedItem?.nextSibling, 0)
        break
      case 'Enter':
        this.#enterEvent(listItems)
        break
      case 'Escape':
      case 'Tab':
        this. #closeEvent(listElement)
        break
      default:
        break
    }
  }

  #generateList(selectElement) {
    let x, listLength, listElement, newSelectElement
    listLength = selectElement.length

    /* Use the native select if mobile device */
    if (this.#isMobile()) return

    /* Use the native select if not mac */
    if (!this.#isMac()) return

    /* Add the class 'custom-select' to the current select selectElement: */
    newSelectElement = selectElement.closest('[data-controller="custom-select"]')
    newSelectElement.classList.add('custom-select')

    /* For each element, create a new DIV that will contain the option list: */
    listElement = newSelectElement.querySelector('.custom-select__list')
    if (!listElement) {
      listElement = document.createElement('div')
      listElement.setAttribute('class', 'custom-select__list')
    } else {
      listElement.innerHTML = ''
    }

    this.#prepareDataAction(selectElement)

    const firstOption = selectElement?.options[0]
    const initialValue = firstOption?.text.trim() === 'Please select' || firstOption?.text.trim() === '' ? 1 : 0
    for (x = initialValue; x < listLength; x++) {
      this.#generateOptionItem(selectElement, listElement, x)
    }

    this.#setOptionInnerLabel(selectElement)

    newSelectElement.appendChild(listElement)
  }

  #setOptionInnerLabel(selectElement) {
    const firstOption = selectElement?.options[0]
    if (firstOption?.text.trim() === 'Please select' || firstOption?.text.trim() === '') {
      firstOption.value = ''
      firstOption.text = 'Please select'
      firstOption.disabled = 'disabled'
    } else {
      const myOption = document.createElement('option')
      myOption.text = 'Please select'
      myOption.disabled = 'disabled'
      selectElement.prepend(myOption)
    }
  }

  #generateOptionItem(selectElement, listElement, index) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    const listItemElement = document.createElement('div')
    if (selectElement.options[index].innerHTML.includes('Please select')) {
      listItemElement.setAttribute('class', 'custom-select__item -disabled')
    } else {
      listItemElement.setAttribute('class', 'custom-select__item')
      listItemElement.setAttribute('data-action', 'click->custom-select#optionClickEvent')
    }
    listItemElement.innerHTML = selectElement.options[index].innerHTML
    if (!!selectElement.value && selectElement.options[index].hasAttribute('selected')) {
      listItemElement.classList.add('-active')
    }
    listElement.appendChild(listItemElement)
  }

  #prepareDataAction(selectElement) {
    /* Cleanup data-actions and add to the 'selectElement' */
    const actions = 'keydown->custom-select#selectKeyEvent click->custom-select#selectClickEvent'
    const existingDataAction = selectElement.getAttribute('data-action')
    const newDataActionList = (`${actions} ${existingDataAction || ''}`).split(' ')
    const uniqueDataActionList = [...new Set(newDataActionList)]
    selectElement.setAttribute('data-action', uniqueDataActionList?.join(' ')?.trim())
  }

  #enterEvent(listElement) {
    const currentSelectedIndex = Object.values(listElement).findIndex(item => item?.classList.contains('-active'))
    const selectElement = listElement[0]?.closest('.custom-select').getElementsByTagName('select')[0]
    this.#selectItem(selectElement, currentSelectedIndex + 1)
  }

  #closeEvent(listElement) {
    listElement?.classList.remove('-open')
  }

  #selectItem(item, index) {
    item.selectedIndex = index
    item.dispatchEvent(new Event('change'))
    this.#closeAllSelect()
  }

  #activeElement(listElement) {
    return listElement.querySelector('.-active')
  }

  #navigateList(list, selected, next, index) {
    if (selected?.classList.contains('-active')) {
      selected.classList.remove('-active')
      if (next) {
        selected = next.classList.add('-active')
      } else {
        selected = list[index].classList.add('-active')
      }
    } else {
      selected = list[index].classList.add('-active')
    }

    /* Scroll container to offset of the '-active' div */
    const scrollTo = this.#activeElement(list[index].closest('.custom-select__list'))
    scrollTo && (scrollTo.parentNode.scrollTop = scrollTo.offsetTop)
  }

  #closeAllSelect() {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    const listElements = document.getElementsByClassName('custom-select__list')
    removeClassFromList(listElements, '-open')
  }
}
